"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeniedField = void 0;
const joi_1 = __importDefault(require("joi"));
const field_1 = require("../field");
const field_types_1 = require("../../../types/field_types");
class DeniedField extends field_1.Field {
    constructor() {
        super(...arguments);
        this.acceptFilterOperators = [];
    }
    get basicValueType() {
        return field_types_1.BasicValueType.String;
    }
    get apiMetaProperty() {
        return null;
    }
    get openValueJsonSchema() {
        return {
            title: this.field.name,
            type: 'string'
        };
    }
    static defaultProperty() {
        return null;
    }
    validateProperty() {
        return DeniedField.propertySchema.validate(this.field.property);
    }
    validateCellValue() {
        return this.validateProperty();
    }
    validateOpenWriteValue() {
        return this.validateProperty();
    }
    cellValueToStdValue(_cellValue) {
        return {
            sourceType: this.field.type,
            data: [],
        };
    }
    stdValueToCellValue(_stdValue) {
        return null;
    }
    recordEditable() {
        return false;
    }
    validate(_value) {
        return false;
    }
    cellValueToString(_cellValue) {
        return null;
    }
    defaultValueForCondition(_condition) {
        return null;
    }
    cellValueToApiStandardValue(_cellValue) {
        return null;
    }
    cellValueToApiStringValue(_cellValue) {
        return null;
    }
    cellValueToOpenValue(_cellValue) {
        return null;
    }
    openWriteValueToCellValue(_openWriteValue) {
        return null;
    }
}
exports.DeniedField = DeniedField;
DeniedField.propertySchema = joi_1.default.equal(null);
//# sourceMappingURL=denied_field.js.map